export const URL_GET_CHECKIN_LIST = '/v1/gocheckin/checkin/site/list?';
export const URL_GET_STAFF_BY_SERVICE = '/v1/gocheckin/service/employee-service/list-staff-by-service?';
export const URL_GET_CHECKOUT_HISTORY = '/v1/gocheckin/checkout/site/history?';
export const URL_GET_CHECKOUT_HISTORY_SUMMARY = '/v1/gocheckin/checkout/site/summary';
export const URL_GET_CHECKOUT_INFO = '/v1/gocheckin/checkout/site/info?';
export const URL_CHECKOUT_SUBMIT = '/v1/gocheckin/checkout/form/submit';
export const URL_UPDATE_CUSTOMER_NOTE = '/v1/gocheckin/checkout/customer/update';
export const URL_CHECK_PHONE = '/v1/gocheckin/checkin/form/checkin';
export const URL_CHECKIN_SUBMIT = '/v1/gocheckin/checkin/form/checkin-submit';
export const URL_LOGIN = '/v1/gocheckin/checkin/form/login';
export const URL_UPDATE_STAFF = '/v1/gocheckin/checkout/staff/update';
export const URL_UPDATE_SERVICE = '/v1/gocheckin/checkout/service/update';
export const URL_UPDATE_SERVICE_WITH_STAFF_AND_PRICE = '/v1/gocheckin/checkout/service/update-staff-service';
export const URL_UPDATE_IN_SERVICE_STATUS = '/v1/gocheckin/checkout/form/update-status';
export const URL_CHECK_UPDATE = '/v1/gocheckin/checkout/site/check-update';
export const URL_CHECKOUT_REDEEM = "/v1/gocheckin/checkout/form/redeem";
export const URL_UPDATE_CUSTOMER_CHECKIN_STAFF = "/v1/gocheckin/checkin/form/update-customer-checkin-staff";
export const URL_UPDATE_SMS_SENT = '/v1/gocheckin/checkout/form/update-sms-sent';